<!-- script -->

<!-- header section -->
<header id="headsection" class="header-container-wrapper">
    <div class="main-header d-lg-block d-none border-0">
        <div class="container-wrapper">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="logo">
                        <a>
                            <img src="../../assets/images/wealthmax/logo-2.png" alt="Bajaj Capital Logo">
                        </a>
                    </div>
                    <!-- <div class="col-md-3">

                    </div> -->
                    <div class="col-md-8 d-flex justify-content-end align-items-center">
                        <ul class="tab_list d-none">
                            <li class="list">
                                <a href="#"> <img src="../../assets/images/wealthmax/icons/icon-1.svg" width="20"
                                        alt="icon"> For
                                    Individuals</a>
                            </li>
                            <li class="list">
                                <a href="#"> <img src="../../assets/images/wealthmax/icons/icon-2.svg" width="20"
                                        alt="icon"> For
                                    Corporates</a>
                            </li>
                            <li class="list">
                                <a href="#"> <img src="../../assets/images/wealthmax/icons/icon-3.svg" width="20"
                                        alt="icon"> Financial
                                    Horoscope</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-header d-lg-none">
        <div class="container">
            <div class="row">
                <div class="col-2 pr-0 d-none">
                    <div class="mobile-header-links justify-content-center">
                        <a onclick="OpenSideBar()" class="hamburger-menu d-flex text-white">
                            <span class="material-icons-outlined" id="menuicon">
                                menu
                            </span>
                        </a>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mobile-logo">
                        <a class="logo">
                            <img src="../../assets/images/wealthmax/logo-2.png" alt="" width="120">
                        </a>
                    </div>
                </div>
                <div class="col-5 d-flex justify-content-end align-items-center">

                </div>
            </div>
        </div>
    </div>
</header>
<!-- header section  -->

<main>
    <button onclick="topFunction()" id="myBtn" title="Go to top">
        <img src="../../assets/images/cas/bottom-img.png" alt="top">
    </button>
    <section class="hero_banner">
        <div class="container character">
            <div class="row">
                <div class="col-xl-7 col-lg-7 col-md-12">
                    <div class="content">
                        <h1 class="heading">Your Money, Your Future.</h1>
                        <div class="inner d-flex align-items-start">
                            <span class="heading">Wealthmax will help you</span>
                            <ul class="ms-slider__words">
                                <li class="ms-slider__word">Optimize</li>
                                <li class="ms-slider__word">Manage</li>
                                <li class="ms-slider__word">Strengthen</li>
                                <li class="ms-slider__word">Optimize</li>
                            </ul>
                        </div>
                    </div>
                    <img src="../../assets/images/cas/hero-img.png" alt="heroimg" class="heroimg">
                </div>
                <div class="col-xl-5 col-lg-5 col-md-12">
                    <div class="form" id="form1">
                        <h2 class="form-title">
                            Generate Mutual Fund Portfolio Report 
                        </h2>
                        <div *ngIf="successMessage" class="text-center successMessage">
                            {{ successMessage }}                    
                        </div>
                        <div *ngIf="!successMessage">
                            <form #leadForm="ngForm">
                                <!-- FULL NAME -->
                                <div class="form-group">
                                    <label for="name">Full Name</label>
                                
                                    <input type="text" class="form-control" name="uname" [(ngModel)]="name" required minlength="3" maxlength="70"
                                        pattern="^[A-Za-z ]+$" #uname="ngModel" placeholder="Enter your Full Name" [disabled]="formLocked"
                                        (keypress)="onlyLetters($event)" (paste)="onPasteName($event)">
                                
                                    <div class="error" *ngIf="uname.invalid && uname.touched">
                                        <div *ngIf="uname.errors?.['required']">
                                            Full Name is required
                                        </div>
                                
                                        <div *ngIf="uname.errors?.['minlength']">
                                            Minimum 3 characters required
                                        </div>
                                
                                        <div *ngIf="uname.errors?.['pattern']">
                                            Only letters and spaces are allowed
                                        </div>
                                    </div>                            
                                </div>

                                <!-- PAN -->
                                <div class="form-group">
                                    <label class="mauticform-labels">PAN Number</label>
                                    <input type="text" class="form-control" name="pan" [(ngModel)]="pan" required
                                        pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}" #panField="ngModel"
                                        minlength="10" maxlength="10"
                                        placeholder="Enter PAN Number" style="text-transform: uppercase"
                                        (input)="convertPanToUppercase()" [disabled]="formLocked">

                                    <div class="error" *ngIf="panField.invalid && panField.touched">
                                        Enter valid PAN (ABCDE1234F)
                                    </div>
                                </div>

                                <!-- EMAIL -->
                                <div class="form-group">
                                    <label for="email">Email Address</label>
                                
                                    <input type="email" class="form-control" name="uemail" [(ngModel)]="email" required email #emailField="ngModel"
                                        placeholder="Enter your Email Address" [disabled]="formLocked">
                                
                                    <!-- Required validation -->
                                    <div class="error" *ngIf="emailField.errors?.['required'] && emailField.touched">
                                        Email is required
                                    </div>
                                
                                    <!-- Email format validation -->
                                    <div class="error" *ngIf="emailField.errors?.['email'] && emailField.touched">
                                        Enter a valid Email
                                    </div>
                                
                                    <img src="../../../assets/images/cas/check_circle.svg" class="checkcircle" id="checkcircle" alt="checkcircle">                            
                                </div>

                                <!-- MOBILE -->
                                <div class="form-group" id="mobile_number">
                                    <label for="mobile">Mobile Number</label>
                                
                                    <input type="tel" class="form-control" name="umobile" [(ngModel)]="mobile" required pattern="^[6-9][0-9]{9}$"
                                        maxlength="10" minlength="10" #mobileField="ngModel" placeholder="Enter your Mobile Number"
                                        [disabled]="formLocked" inputmode="numeric" (keypress)="onlyNumbers($event)" (paste)="onPaste($event)">
                                
                                    <!-- Required -->
                                    <div class="error" *ngIf="mobileField.errors?.['required'] && mobileField.touched">
                                        Mobile number is required
                                    </div>
                                
                                    <!-- Pattern -->
                                    <div class="error" *ngIf="mobileField.errors?.['pattern'] && mobileField.touched">
                                        Enter valid 10 digit mobile (starts with 6–9)
                                    </div>                            
                                </div>

                                <!-- OTP DIV -->
                                <!-- <div class="form-group otp-container" id="otpdiv" *ngIf="showOtp">
                                    <input type="text" 
                                        class="form-control" 
                                        id="otp" 
                                        name="otp" 
                                        [(ngModel)]="otp" 
                                        required
                                        minlength="6" 
                                        maxlength="6" 
                                        inputmode="numeric"
                                        #otpField="ngModel" 
                                        placeholder="Enter OTP here" 
                                        [disabled]="otpVerified" />
                                        <span class="resendOtpTimer">
                                            00:{{ otpTimer }}s                           
                                        </span>
                                    <div class="error" *ngIf="otpField.invalid && otpField.touched">
                                        OTP must be 6 digits
                                    </div>

                                    <div class="error" *ngIf="invalidOtpStatus" style="color:red;">
                                        {{ otpErrorMessage }}                          
                                    </div>
                                    <button type="button" class="btn btn-link resendOtp" [disabled]="!canResend" (click)="resendOTP()">
                                        Resend OTP
                                    </button>

                                    <div class="edit-wrapper">
                                        <label for="mobile" id="editnumber" (click)="editNumber()">
                                            EDIT MOBILE NUMBER
                                        </label>
                                    </div>
                                </div> -->

                                <!-- GENERATE OTP BUTTON -->
                                <!-- <div class="text-center" *ngIf="!showOtp">
                                    <button type="button" class="btn btn-primary" [disabled]="leadForm.invalid || loading"
                                        (click)="generateOTP()">
                                        <span *ngIf="!loading">Generate OTP</span>
                                        <span *ngIf="loading">Generating OTP...</span>
                                    </button>
                                </div> -->

                                <!-- SUBMIT BUTTON -->
                                <div class="text-center">
                                    <button type="button" class="btn btn-primary submit-btn" [disabled]="leadForm.invalid || loading || isSubmitting"
                                        (click)="generateOTP()">
                                
                                        <span *ngIf="!loading && !isSubmitting">Submit</span>
                                
                                        <span *ngIf="loading || isSubmitting">
                                            <i class="spinner-border spinner-border-sm"></i>
                                            Processing...
                                        </span>
                                    </button>                        
                                </div>

                            </form>

                        </div>

                        <div class="leadform">
                            <p class="consent">
                                By continuing, you provide consent and agree to our
                                <a href="https://www.bajajcapital.com/term-conditions?doc=tnc" target="_blank"
                                    class="link">Terms & Conditions</a>
                                and <a href="https://www.bajajcapital.com/privacy/bajaj-capital-privacy-policy"
                                    target="_blank" class="link">Privacy Policy</a>.
                            </p>
                        </div>

                    </div>
                </div>
                <div class="col-md-12">
                    <div class="arrow">
                        <a id="scrollButton">
                            <img src="../../assets/images/wealthmax/scroll-down.gif" width="88" alt="icon">
                            <p class="scrolltxt">Scroll down to explore</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="wonder">
        <div class="container">
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab"
                        aria-controls="nav-home" aria-selected="true">What is CAS?</a>
                    <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab"
                        aria-controls="nav-profile" aria-selected="false">How to access CAS file?</a>
                    <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab"
                        aria-controls="nav-contact" aria-selected="false">What will you get?</a>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <p class="text">CAS or Consolidated Account Statement is a combined account
                                    statement that shows financial transactions made by an investor during chosen
                                    time period across all mutual funds and other securities held in a
                                    dematerialised or demat mode. The statement provides a comprehensive view of the
                                    investor’s holdings across funds serviced by all the RTAs or Registrar and
                                    Transfer Agents.</p>
                                <p class="text">You can generate your CAMS + KFintech Consolidated Account Statement
                                    by visiting
                                    the CAMS online portal.</p>
                            </div>
                            <div class="col-md-6">
                                <div class="sidebox">
                                    <img src="../../assets/images/cas/faq1.png" class="img-fluid w-100" alt="faq">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="sidebox2">
                                    <div class="accordion" id="accordionExample">
                                        <div class="card">
                                            <div class="card-header" id="headingOne">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link" type="button" data-toggle="collapse"
                                                        data-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        <p class="headline">How to Download a CAS File from CAMS</p>
                                                    </button>
                                                </h2>
                                            </div>

                                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <ol class="order-list">
                                                        <li class="list"><strong>Visit the CAMS Website</strong>
                                                        </li>
                                                        <ul class="listing">
                                                            <li>Go to <a
                                                                    href="https://www.camsonline.com/Investors/Statements/Consolidated-Account-Statement"
                                                                    target="_blank">CAMS Online</a> in your browser.
                                                            </li>
                                                        </ul>
                                                        <li class="list"><strong>Choose Statement Type and
                                                                Period</strong></li>
                                                        <ul class="listing">
                                                            <li><strong>Statement Type:</strong> Select “Detailed.”
                                                            </li>
                                                            <li><strong>Period:</strong> Choose “Specific Period.”
                                                            </li>
                                                            <li><strong>From Date:</strong> For example, enter
                                                                "01-Apr-2001."</li>
                                                            <li><strong>To Date:</strong> Keep it as is or select
                                                                the end date you want.</li>
                                                        </ul>
                                                        <li class="list"><strong>Set Folio and Email
                                                                Preferences</strong></li>
                                                        <ul class="listing">
                                                            <li><strong>Folio Listing:</strong> Choose “Without Zero
                                                                Balanced folios.”
                                                            </li>
                                                            <li><strong>Email:</strong> Enter your registered email
                                                                ID.
                                                            </li>
                                                        </ul>
                                                        <li class="list"><strong>Create a Password</strong></li>
                                                        <ul class="listing">
                                                            <li>Set a password to secure your CAS file.</li>
                                                        </ul>
                                                        <li class="list"><strong>Authenticate Your Request</strong>
                                                        </li>
                                                        <ul class="listing">
                                                            <li>Enter the OTP sent to your registered email or
                                                                mobile
                                                                number.</li>
                                                        </ul>
                                                        <li class="list"><strong>Download Your CAS</strong></li>
                                                        <ul class="listing">
                                                            <li>The CAS will be emailed to you in a
                                                                password-protected PDF. Use the password you have
                                                                set earlier to view it.</li>
                                                        </ul>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link collapsed" type="button"
                                                        data-toggle="collapse" data-target="#collapseTwo"
                                                        aria-expanded="false" aria-controls="collapseTwo">
                                                        <p class="headline">How to Download a CAS File from NSDL</p>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <ol class="order-list">
                                                        <li class="list"><strong>Visit the NSDL CAS Portal</strong>
                                                        </li>
                                                        <ul class="listing">
                                                            <li>Go to <a href="https://nsdlcas.nsdl.com/"
                                                                    target="_blank">NSDL CAS Portal</a>.</li>
                                                        </ul>
                                                        <li class="list"><strong>Register for CAS (if new)</strong>
                                                        </li>
                                                        <ul class="listing">
                                                            <li><strong>Click “New Registration.”</strong></li>
                                                            <li><strong>Enter:</strong></li>
                                                            <ul class="listing">
                                                                <li><strong>PAN:</strong> Your Permanent Account
                                                                    Number.</li>
                                                                <li><strong>Email ID:</strong> Your registered email
                                                                    address.</li>
                                                                <li><strong>Mobile Number:</strong> Linked with your
                                                                    Demat account.</li>
                                                            </ul>
                                                        </ul>
                                                        <li class="list"><strong>Retrieve your CAS ID (if
                                                                needed)</strong></li>
                                                        <ul class="listing">
                                                            <li>If you don’t know your CAS ID:</li>
                                                            <ul class="listing">
                                                                <li>Click “Know Your CAS ID.”</li>
                                                                <li>Enter your <strong>PAN</strong>.</li>
                                                                <li>Provide:</li>
                                                                <ul class="listing">
                                                                    <li><strong>DP Name & DP ID:</strong> The DP
                                                                        (Depository Participant) is your broker,
                                                                        e.g., Zerodha. The DP ID is the first 8
                                                                        digits of your Demat account number.</li>
                                                                    <li><strong>Client ID:</strong> The last 8
                                                                        digits of your Demat account number.</li>
                                                                </ul>
                                                            </ul>
                                                        </ul>
                                                        <li class="list"><strong>Download Your CAS</strong></li>
                                                        <ul class="listing">
                                                            <li>Log in using your CAS ID or Client ID.</li>
                                                            <li>Select the time period for your CAS.</li>
                                                            <li>Download the CAS as a password-protected PDF.</li>
                                                        </ul>
                                                        <p class="note">Note: Your password is usually your PAN (in
                                                            uppercase) </p>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingThree">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link collapsed" type="button"
                                                        data-toggle="collapse" data-target="#collapseThree"
                                                        aria-expanded="false" aria-controls="collapseThree">
                                                        <p class="headline">How to Download a CAS File from CDSL</p>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <ol class="order-list">
                                                        <li class="list"><strong>Visit the CDSL Website</strong>
                                                        </li>
                                                        <ul class="listing">
                                                            <li>Open <a
                                                                    href="https://www.cdslindia.com/cas/logincas.aspx"
                                                                    target="_blank">CDSL CAS</a> in your browser.
                                                            </li>
                                                        </ul>
                                                        <li class="list"><strong>Enter Your Details</strong></li>
                                                        <ul class="listing">
                                                            <li><strong>PAN Number</strong></li>
                                                            <li><strong>BO ID or Demat Number:</strong> Find this in
                                                                your broker’s app or website under account details.
                                                            </li>
                                                            <li><strong>Date of Birth (DOB)</strong></li>
                                                            <li><strong>Submit</strong></li>
                                                        </ul>
                                                        <li class="list"><strong>Choose Download CAS from Header
                                                                Options.</strong></li>

                                                        <li class="list"><strong>Select Period:</strong> Month and
                                                            Year</li>
                                                        <li class="list"><strong>Authenticate Your Request</strong>
                                                        </li>
                                                        <ul class="listing">
                                                            <li>Enter the OTP sent to your registered email or
                                                                mobile number.</li>
                                                        </ul>
                                                        <li class="list"><strong>Download Your CAS</strong></li>
                                                        <ul class="listing">
                                                            <li>Download the CAS as a password-protected PDF.</li>
                                                        </ul>
                                                        <li class="list"><strong>Password Tip:</strong> Your
                                                            password is usually your PAN (in uppercase)</li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="sidebox3">
                                    <p class="headline"><span class="text-white">Wealthmax Benefits</span></p>
                                    <ul class="listing">
                                        <li><strong>Clear Portfolio Overview:</strong> Get a
                                            snapshot of your
                                            portfolio's current performance through Wealthmax report.</li>
                                        <li><strong>Risk Spotting:</strong> Identify potential
                                            risks that could affect your returns.
                                        </li>
                                        <li><strong>Unlock Hidden Opportunities:</strong> Ensure
                                            you're not missing
                                            out on valuable growth potential.</li>
                                        <li><strong>Evaluate v/s Market Trends:</strong> Compare
                                            your portfolio with
                                            current market trends to stay on top.</li>
                                        <li><strong>Check for Risk & Diversification:</strong>
                                            Secure your
                                            investments with a thorough risk and diversification check.</li>
                                        <li><strong>1-on-1 Expert Call:</strong> Get all your
                                            questions answered
                                            directly by an expert.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="sidebox3">
                                    <img src="../../assets/images/cas/faq2.png" class="img-fluid w-100" alt="img">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="intro-wm">
        <div class="container">
            <div class="content">
                <h3 class="subheading">Explore Endless <span class="clr">Possibilities</span></h3>
            </div>

            <div class="gridview">
                <div class="gridviewwrapper">
                    <article id="B1">
                        <h5 class="heading">Position Overlap</h5>
                        <img src="../../assets/images/cas/la-premier/1.png" class="img-fluid" alt="la-premier">
                        <p class="text">Identify how much overlap exists in your holdings to prevent redundant
                            investments and optimize growth potential.</p>
                    </article>
                    <article id="B2">
                        <div class="B2Wrapper">
                            <div class="B2Inner">
                                <h5 class="heading">Fund Comparison & Ranking</h5>
                                <p class="text">Compare all your funds in one place, ranked and valued based on our
                                    models, to make smarter investment choices</p>
                            </div>
                            <img src="../../assets/images/cas/la-premier/2.png" class="img-fluid" alt="la-premier">
                        </div>
                    </article>
                    <article id="B3">
                        <img src="../../assets/images/cas/la-premier/3.png" class="img-fluid" alt="la-premier">
                        <h5 class="heading">Market Insights</h5>
                        <p class="text">Stay informed with the latest business and economic news, stock updates, and
                            fund insights for smart decision-making.</p>
                    </article>
                    <article id="B4">
                        <h5 class="heading">Correlation Analysis</h5>
                        <p class="text">Understand the relationships among funds to diversify intelligently and
                            minimize risk exposure</p>
                        <img src="../../assets/images/cas/la-premier/4.png" class="img-fluid" alt="la-premier">
                    </article>
                    <article id="B5">
                        <h5 class="heading">Sector-Wise Yearly Performance
                        </h5>
                        <p class="text">Assess which sectors are performing well to make industry-aligned investment
                            choices and make portfolio future proof</p>
                        <img src="../../assets/images/cas/la-premier/5.png" class="img-fluid" alt="la-premier">
                    </article>
                    <article id="B6">
                        <h5 class="heading">Optimize Your Portfolio</h5>
                        <p class="text">Get custom insights to adjust your portfolio and enhance performance with
                            our expertly crafted investment models</p>
                        <img src="../../assets/images/cas/la-premier/6.png" class="img-fluid" alt="la-premier">
                    </article>
                </div>
            </div>
        </div>
    </section>
    <section class="stack">
        <div class="stack__card">
            <h5 class="heading">Position Overlap</h5>
            <img src="../../assets/images/cas/la-premier/1.png" class="img-fluid" alt="la-premier">
            <p class="text">Investors unknowingly duplicate investments across multiple mutual funds, as they don't
                know if AMCs are investing in the same stocks.</p>
        </div>
        <div class="stack__card">
            <h5 class="heading mb-0">Fund Selection</h5>
            <p class="text">With 1,386 mutual fund schemes in India, selecting the right funds becomes overwhelming
                - like finding a needle in a haystack.</p>
            <img src="../../assets/images/cas/la-premier/2.png" class="img-fluid" alt="la-premier">
        </div>
        <div class="stack__card">
            <img src="../../assets/images/cas/la-premier/3.png" class="img-fluid" alt="la-premier">
            <h5 class="heading">Market Monitoring</h5>
            <p class="text">Keeping up with fast-moving markets during volatile times (Ukraine-Russia War, Israeli
                conflict, US Elections) is nearly impossible to track effectively.</p>
        </div>
        <div class="stack__card">
            <h5 class="heading mb-0">True Diversification</h5>
            <p class="text">While everyone talks about diversification, understanding the correlation between
                investments is difficult due to lack of proper analysis tools.</p>
            <img src="../../assets/images/cas/la-premier/4.png" class="img-fluid" alt="la-premier">
        </div>
        <div class="stack__card">
            <img src="../../assets/images/cas/la-premier/5.png" class="img-fluid" alt="la-premier">
            <h5 class="heading">Sector Selection</h5>
            <p class="text">Different sectors perform differently each year, and conflicting advice from various
                fund managers makes it difficult to know where to invest</p>
        </div>
        <div class="stack__card">
            <h5 class="heading mb-0">Optimize Your Portfolio</h5>
            <p class="text">Get custom insights to adjust your portfolio and enhance performance with our expertly
                crafted investment models</p>
            <img src="../../assets/images/cas/la-premier/6.png" class="img-fluid" alt="la-premier">
        </div>
    </section>
    <section class="portfolio">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-xl-7 col-md-12 d-flex justify-content-between">
                    <ul class="featured-products-list ul">
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Is your portfolio over-exposed to one sector? Find out now!</p>
                                <img draggable="false" src="../../assets/images/cas/icons/1.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Where do your schemes land on the risk-return matrix? Get the
                                    insights now.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/2.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Want to see how different schemes compare? Let’s find the best one
                                    for you.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/3.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Optimize your withdrawals to ensure your fund performs at its best
                                    and maximizes return with Monthly SWP</p>
                                <img draggable="false" src="../../assets/images/cas/icons/4.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Curious how your portfolio measures up against benchmarks like the
                                    Nifty50 and across other indices?</p>
                                <img draggable="false" src="../../assets/images/cas/icons/5.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Find out exactly how to reallocate your schemes to maximise the
                                    returns</p>
                                <img draggable="false" src="../../assets/images/cas/icons/6.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Is your portfolio over-exposed to one sector? Find out now!</p>
                                <img draggable="false" src="../../assets/images/cas/icons/1.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Where do your schemes land on the risk-return matrix? Get the
                                    insights now.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/2.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Want to see how different schemes compare? Let’s find the best one
                                    for you.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/3.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Optimize your withdrawals to ensure your fund performs at its best
                                    and maximizes return with Monthly SWP</p>
                                <img draggable="false" src="../../assets/images/cas/icons/4.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Curious how your portfolio measures up against benchmarks like the
                                    Nifty50 and across other indices?</p>
                                <img draggable="false" src="../../assets/images/cas/icons/5.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product-card">
                            <div class="product-card-img">
                                <p class="text">Find out exactly how to reallocate your schemes to maximise the
                                    returns</p>
                                <img draggable="false" src="../../assets/images/cas/icons/6.png" alt="" />
                            </div>
                        </li>
                    </ul>
                    <ul class="ul featured2">
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Is your portfolio spread across CAMS, NSDL, and CDSL? Review all
                                    your investments in one go with our experts.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/7.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Does your portfolio have a safety net with debt investments?</p>
                                <img draggable="false" src="../../assets/images/cas/icons/8.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Is your portfolio quietly underperforming? Let's uncover the truth
                                </p>
                                <img draggable="false" src="../../assets/images/cas/icons/9.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Curious about how much your holdings overlap in your schemes? You
                                    might be surprised!</p>
                                <img draggable="false" src="../../assets/images/cas/icons/10.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Get in-depth insights on fund performance, AUM, risk factors, and
                                    ratings—all in one place.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/11.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Is your portfolio spread across CAMS, NSDL, and CDSL? Review all
                                    your investments in one go with our experts.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/7.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Does your portfolio have a safety net with debt investments?</p>
                                <img draggable="false" src="../../assets/images/cas/icons/8.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Is your portfolio quietly underperforming? Let's uncover the truth
                                </p>
                                <img draggable="false" src="../../assets/images/cas/icons/9.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Curious about how much your holdings overlap in your schemes? You
                                    might be surprised!</p>
                                <img draggable="false" src="../../assets/images/cas/icons/10.png" alt="" />
                            </div>
                        </li>
                        <li class="product-cards product2">
                            <div class="product-card-img">
                                <p class="text">Get in-depth insights on fund performance, AUM, risk factors, and
                                    ratings—all in one place.</p>
                                <img draggable="false" src="../../assets/images/cas/icons/11.png" alt="" />
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-5 col-xl-5 col-md-12">
                    <div class="content">
                        <h4 class="heading">Millionaires' Portfolio Analytics Tool—Now Available for <span
                                class="span">Each of Us</span></h4>
                        <p class="text">Understad what’s working and what’s not in your portfolio, with insights on
                            returns, volatility, and asset allocation, empowering you to make informed decisions
                            about your investments and maximize your returns.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="whatsapp">
        <h3 class="heading">By the Investors. To the Investors. For the Investors</h3>
        <div class="element"></div>
        <div class="slick">
            <div><span><img src="../../assets/images/cas/WA/1.png" width="300" style="margin: auto;" /></span></div>
            <div><span><img src="../../assets/images/cas/WA/2.png" width="300" style="margin: auto;" /></span></div>
            <div><span><img src="../../assets/images/cas/WA/3.png" width="300" style="margin: auto;" /></span></div>
            <div><span><img src="../../assets/images/cas/WA/4.png" width="300" style="margin: auto;" /></span></div>
            <div><span><img src="../../assets/images/cas/WA/5.png" width="300" style="margin: auto;" /></span></div>
            <div><span><img src="../../assets/images/cas/WA/6.png" width="300" style="margin: auto;" /></span></div>
        </div>
    </section>
    <footer class="reviewed">
        <div class="container content">
            <h4 class="heading"><span class="span">Now is the right time to get your </span></h4>
            <p class="sub_heading">Investments Reviewed </p>
            <a (click)="scrollToTop()" class="btn started">Get Started</a>
        </div>
    </footer>

    <!-- report generation failed  -->
    <div class="report-fail" *ngIf="error_msg">
        <div class="wrapper">
            <button class="btn" (click)="closeError()"><img src="../../../assets/images/cancel-icon.png" width="20"
                    alt="icon"></button>
            <img src="../../../assets/images/warning.png" class="_icon" alt="icon">
            <p class="_msg">Report generation failed. Please allow email access by checking the box on the Google
                Sign-In screen.</p>
        </div>
    </div>
    <!-- report generation failed  -->
    <!-- new popup 04-11-25  -->
    <div class="_multipleuser" id="_multipleuser">
        <div class="_inner">
            <button class="_cross" (click)="cancelMultipleUserPopup()">
                <img src="../../../assets/images/casnew/cancel.png" width="40" alt="cancel">
            </button>
            <img src="../../../assets/images/casnew/cas-loader.gif" width="94" alt="loader">
            <h3 class="_heading">Your WealthMax report is being prepared!</h3>
            <p class="_txt">It will be in your WhatsApp inbox within 10 minutes.</p>
        </div>
    </div>
    <!-- new popup 04-11-25  -->
</main>